var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup890(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(509.98 -132.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M-497.484,132.932a12.5,12.5,0,0,1,12.5,12.535A12.506,12.506,0,0,1-497.5,157.932,12.5,12.5,0,0,1-509.98,145.37,12.508,12.508,0,0,1-497.484,132.932Zm.013,10.832q-2.864,0-5.729,0a2.049,2.049,0,0,0-.388.025,1.672,1.672,0,0,0-1.39,1.795,1.677,1.677,0,0,0,1.72,1.514c1.059,0,2.118,0,3.177,0q4.179,0,8.359,0a1.642,1.642,0,0,0,1.352-.6,1.584,1.584,0,0,0,.225-1.777,1.585,1.585,0,0,0-1.519-.953C-493.6,143.759-495.535,143.764-497.471,143.764Z",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup890);
export default __webpack_public_path__ + "static/media/Group 890.0f2735c7b083e855b54386fd781eab18.svg";
export { ForwardRef as ReactComponent };